"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.IconDesktopOutline = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var IconDesktopOutline = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24px' : _b, style = _a.style;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: __assign(__assign({ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }, style), { height: size, width: size }) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                position: 'relative',
                height: 0,
                width: '100%',
                padding: 0,
                paddingBottom: '100%'
            } }, { children: (0, jsx_runtime_1.jsxs)("svg", __assign({ style: {
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    left: 0,
                    top: 0
                }, viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("rect", { x: "32", y: "64", width: "448", height: "320", rx: "32", ry: "32", fill: "none", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "32" }, void 0), (0, jsx_runtime_1.jsx)("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M304 448l-8-64h-80l-8 64h96z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M368 448H144" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M32 304v48a32.09 32.09 0 0032 32h384a32.09 32.09 0 0032-32v-48zm224 64a16 16 0 1116-16 16 16 0 01-16 16z", fill: "currentColor" }, void 0)] }), void 0) }), void 0) }), void 0));
};
exports.IconDesktopOutline = IconDesktopOutline;
